import { render, staticRenderFns } from "./WDetalleApuesta.vue?vue&type=template&id=4f170199&scoped=true&"
import script from "./WDetalleApuesta.vue?vue&type=script&lang=js&"
export * from "./WDetalleApuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f170199",
  null
  
)

export default component.exports